module.exports = __webpack_public_path__ + "static/media/17e-03_ST-2017-305x610cm-oleo-sobre-madera.4402a3da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/17e/17e-03_ST-2017-305x610cm-oleo-sobre-madera.jpg
// module id = 216
// module chunks = 0